import React from 'react';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'LOWRISK' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  }
  return 'yellow';
};

const colorSeverityItemCircular = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK' || severety.toUpperCase() === 'WORSE') {
    return 'circular-red';
  } else if (severety.toUpperCase() === 'LOWRISK' || severety.toUpperCase() === 'BETTER') {
    return 'circular-green';
  }
  return 'circular-yellow';
};

const textTrend = trend => {
  let text;
  if (trend.toUpperCase() === 'BETTER') {
    text = `mejora respecto al período anteriror`;
  } else if (trend.toUpperCase() === 'WORSE') {
    text = `Baja respecto al período anteriror`;
  }
  return text;
};

const arrow = trend => {
  let text;
  if (trend.toUpperCase() === 'BETTER') {
    text = <i className="fas fa-arrow-up" />;
  } else if (trend.toUpperCase() === 'WORSE') {
    text = <i className="fas fa-arrow-down" />;
  }
  return text;
};

const nfa = value => {
  if (value === 1) {
    return 'green';
  } else if (value === 2) {
    return 'yellow';
  } else if (value === 3) {
    return 'orange';
  }
  return 'red';
};

const Ranking = props => (
  <div className="container-ranking">
    <div className="container-detail-ranking" onScroll={props.handleScroll}>
      <h2>{props.language.detail_fatigue.nfa.driverRanking}</h2>
      <div className="header-ranking">
        <ul>
          <li className="wd100 center">
            <a
              role="button"
              data-type="ranking"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100"
            >
              {props.language.detail_fatigue.nfa.rankinNunber} <i className="fas fa-arrows-alt-v" />
            </a>
          </li>
          <li>
            <a
              role="button"
              data-type="alias"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100"
            >
              {props.language.detail_fatigue.nfa.driverName}
              <i className="fas fa-arrows-alt-v" />
            </a>
          </li>
          <li className="wd100">
            <a
              role="button"
              data-type="averageRisk"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100"
            >
              {props.language.detail_fatigue.nfa.riskPeriod}
              <i className="fas fa-arrows-alt-v" />
            </a>
          </li>
          <li className="wd50 center">
            <a
              role="button"
              data-type="nfa"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100"
            >
              NFA <i className="fas fa-arrows-alt-v" />
            </a>
          </li>
        </ul>
      </div>
      <div className="box-detail-ranking">
        <table>
          <tbody>
            {props.ranking.map((item, i) => (
              <tr
                key={i}
                onClick={props.link}
                data-driverid={item.id}
                data-driveralias={item.alias}
              >
                <th>{item.ranking}</th>
                <td>
                  <h3>{item.alias}</h3>
                  <h4>
                    {props.language.filter[props.main.toLowerCase()]}:{` `}
                    {item.tags.map((item, i) => (i === 0 ? item : ` - ${item}`))}
                  </h4>
                </td>
                <td className="td-circular">
                  <CircularProgress
                    className={colorSeverityItemCircular(item.averageRisk.value.risk)}
                    variant="static"
                    value={item.averageRisk.value.value}
                    thickness={3}
                    size={50}
                  />
                  <h5 className={colorSeverityItem(item.averageRisk.value.risk)}>
                    {item.averageRisk.value.value}%
                  </h5>
                  <span className={colorSeverityItem(item.averageRisk.trend)}>
                    {arrow(item.averageRisk.trend)}
                    <div>
                      <h6 className={colorSeverityItem(item.averageRisk.trend)}>
                        {item.averageRisk.difference}% {textTrend(item.averageRisk.trend)}
                      </h6>
                      <p>
                        {props.language.detail_fatigue.nfa.previousPeriod} (
                        {moment(item.averageRisk.previousValue.start).format('DD-MM')}{' '}
                        {props.language.detail_fatigue.nfa.to}
                        {moment(item.averageRisk.previousValue.end).format('DD-MM')}){' '}
                        <span className={colorSeverityItem(item.averageRisk.previousValue.risk)}>
                          {item.averageRisk.previousValue.value}%
                        </span>
                      </p>
                      <p>
                        {props.language.detail_fatigue.nfa.thisPeriod} (
                        {moment(item.averageRisk.value.start).format('DD-MM')}{' '}
                        {props.language.detail_fatigue.nfa.to}
                        {moment(item.averageRisk.value.end).format('DD-MM')}){' '}
                        <span className={colorSeverityItem(item.averageRisk.value.risk)}>
                          {item.averageRisk.value.value}%
                        </span>
                      </p>
                    </div>
                  </span>
                  <h6 className={colorSeverityItem(item.averageRisk.trend)}>
                    {item.averageRisk.difference}%
                  </h6>
                </td>
                <td className="td-point">
                  <h6 className={nfa(item.nfa)}>{item.nfa}</h6>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default Ranking;



// WEBPACK FOOTER //
// ./source/client/components/detail_nfa/ranking.jsx